module.exports = __webpack_public_path__ + "img/excesoVelocidadFlota.b05968f9.svg";